<template>
  <el-breadcrumb separator="/" class="comp-breadcrumb">
    <el-breadcrumb-item :key="index" v-for="(item,index) in items">
      <a v-if="item.path" @click="handleClick(item,items)" :class="item.className || null">{{item.name}}</a>
      <span :class="item.className || null" v-else>{{item.name}}</span>
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
  export default {
    props: ['items', 'click'],
    created () {
      console.log(this.items);
    },
    methods: {
      handleClick (item, items) {
        if (typeof this.click === 'function') {
          this.click(item, items);
        } else {
          this.$router.push({
            path: item.path
          });
        }
      }
    },
  };
</script>

<style lang="less">
  .comp-breadcrumb {
    height: 40px;
    line-height: 40px !important;
    background: white;
    font-size: 14px;
    color: #333333;
    letter-spacing: -0.34px;
    font-weight: bold;
    .el-breadcrumb__item:first-child {
      margin-left: 21px;
    }
  }
</style>



// WEBPACK FOOTER //
// BreadCrumb.vue?f72f534e